import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import SubscriptionBox from "@components/SubcriptionBox/SubcriptionBox";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";

import s from "./SubscriptionBlock.module.scss";

const SubscriptionBlock = ({ data, updateField, settings }) => {
  const { title, description } = data;
  const { blockType } = settings.common;

  return (
    <Container className={s.subscriptionBlock}>
      <Container full={false} className={s.innterWrap}>
        <section>
          <div className={s.info}>
            <h2 className={s.title}>
              <Editor field={{ title }} onChange={updateField} onlyText />
            </h2>
            <p className={s.description}>
              <Editor field={{ description }} onChange={updateField} onlyText />
            </p>
          </div>

          <SubscriptionBox className={s.subscriptionBox} />
        </section>
      </Container>
    </Container>
  );
};

export default SubscriptionBlock;
